import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { YodaSpacing } from '../../yoda-ui/yodaTheme';

export const hiddenBoxStyle: SxProps<Theme> = {
  position: 'absolute',
  opacity: 0,
  pointerEvents: 'none',
  height: 0,
  width: 0,
  overflow: 'hidden',
  paddingY: YodaSpacing.none,
  marginX: YodaSpacing.none,
};
